import { API } from "aws-amplify";
import { getAmenity } from "~/graphql/queries";
import * as APITypes from "~/API";

export const EMPTY_AMENITY: APITypes.Amenity = {
  id: "",
  name: "",
  description: "",
  propertyID: "",
  rules: "",
  availability: [],
  locationDescription: "",
  __typename: "Amenity",
  createdAt: "",
  updatedAt: "",
  reservationRule: {
    __typename: "ReservationRule",
    policy: APITypes.AmenityReservationPolicyOptions.NotAllowed,
    ownerID: "",
    ownerType: APITypes.OwnerType.User,
  },
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const getAmenityDetails = async (amenityID: string) => {
  try {
    const response = (await API.graphql({
      query: getAmenity,
      variables: {
        id: amenityID,
      },
    })) as { data?: APITypes.GetAmenityQuery };

    return {
      success: true,
      data: response.data?.getAmenity || EMPTY_AMENITY,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_AMENITY,
      error,
    };
  }
};
